<template>
  <div>
    <div class="gl_title_bar">
      <div class="gl_tb_left">
        <span class="normaltitle">CME课程</span>
      </div>
      <div style="margin-bottom:10px">
        <el-select v-model="type"
                   size="small"
                   @change="typeChange"
                   placeholder="请选择">
          <el-option v-for="item in typeList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="mid">
      <div class="courseBox"
           v-for="(item,index) in list"
           :key="index">
        <div class="cleft">
          <div class="imgBox">
            <img :src="item.pictureUrl"
                 referrerpolicy="no-referrer"
                 alt="">
          </div>
          <div class="infoBox">
            <div class="title">{{item.pname}}</div>
            <div class="remake">
              <div v-show="item.Attribute">二级学科分类：{{item.Attribute}}</div>
              <div class="type"
                   v-show="item.teacher">项目负责人：{{item.teacher}}</div>
              <div class="time">学时：{{item.hours}}学时</div>
              <div>学分：{{item.category+' '+item.scoreCategory+' - '+item.score}}分</div>
              <!-- <div>{{item.startTime+' - '+item.endTime}}</div> -->
            </div>
          </div>
        </div>
        <div class="cright">
          <div class="schedules">已学习{{(item.studyTime/item.length*100).toFixed(2)}}%</div>
          <div class="btnArr">
            <div class="statusOne"
                 @click="toShow(item.cid)">{{item.status==2?'再次学习':'开始学习'}}</div>
            <span class="typespan">{{item.status==0?'未学完':(item.status==1?'已学完':'已考核')}}</span>
          </div>
        </div>
      </div>
    </div>
    <pagination v-if="page.total>page.pageSize"
                :total="page.total"
                :limit="page.pageSize"
                :page="page.currentPage"
                @page-change="pageChange"></pagination>
    <div class="nolist"
         v-show="list.length==0">
      <img src="../../assets/img/no.png"
           alt="">
      <span>暂无CME课程</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      page: {
        total: 0,
        pageSize: 6,
        currentPage: 1
      },
      typeList: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '未学完'
      }, {
        value: 2,
        label: '已学完'
      }, {
        value: 3,
        label: '已考核'
      }],
      type: 0,
      list: [],
      AuthorId: 0
    };
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = Number(JSON.parse(localStorage.getItem('ResData')).id);
      this.getList()
    }
  },
  methods: {
    pageChange (val) {
      if (this.page.currentPage == val) return
      this.page.currentPage = val;
      this.getList()
    },
    typeChange () {
      this.page.currentPage = 1
      this.getList()
    },
    getList () {
      this.httphelper
        .get('/api/CourseClassApi/GetUserLearprojPageList', {
          userId: this.AuthorId,
          status: Number(this.type),
          page: this.page.currentPage,
          limit: this.page.pageSize
        })
        .then(res => {
          if (res.code == 200) {
            this.list = res.data
            this.page.total = res.totalcount
          }
        })
    },
    toShow (cid) {
      if (this.$cookies.get('token_chinagp')) {
        window.open('https://www.jumingedu.com/qkyx/courseDetails?id=' + cid + '&token=' + this.$cookies.get('token_chinagp'), "_blank")
      } else {
        window.open('https://www.jumingedu.com/qkyx/courseDetails?id=' + cid, "_blank")
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mid {
    display: flex;
    flex-direction: column;
    .courseBox {
        width: 100%;
        height: 195px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0;
        box-sizing: border-box;
        border-bottom: 5px solid #f8f8f8;
        .cleft {
            width: auto;
            height: 100%;
            display: flex;
            align-items: center;
            .imgBox {
                width: 250px;
                height: 100%;
                img {
                    width: 250px;
                    height: 100%;
                }
            }
            .infoBox {
                width: auto;
                height: 100%;
                margin-left: 30px;
                padding-top: 5px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .title {
                    font-size: 16px;
                    color: #333;
                }
                .remake {
                    font-size: 14px;
                    color: #333;
                    line-height: 24px;
                }
            }
        }
        .cright {
            height: 100%;
            padding: 5px 0 6px 0;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .schedules {
                font-size: 14px;
                color: #217473;
                text-align: right;
            }
            .btnArr {
                display: flex;
                align-items: center;
                .statusOne {
                    border: 1px solid #217473;
                    color: #217473;
                    cursor: pointer;
                    width: 80px;
                    height: 26px;
                    box-sizing: border-box;
                    text-align: center;
                    line-height: 26px;
                    font-size: 12px;
                    border-radius: 14px;
                }
                .typespan {
                    margin-left: 30px;
                    font-size: 14px;
                    color: #888;
                }
            }
        }
    }
}
.nolist {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 20px;
    margin-top: 80px;
    color: rgb(99, 99, 99);
    img {
        margin-bottom: 30px;
    }
}
</style>
